module.exports = __webpack_public_path__ + "img/list4.642bccae.jpg";